// Meta Pixel + CAPI helper — client side.
// - Loads fbevents.js once and initialises the Pixel.
// - Sends events with a shared `event_id` to both Pixel (client) and CAPI (server).
// - No-op if REACT_APP_META_PIXEL_ID is empty (dev / preview).
import axios from "axios";

const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || "").trim();
const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";

let _initialised = false;

export function initMetaPixel() {
  if (typeof window === "undefined" || _initialised) return;
  if (!PIXEL_ID) return; // silent no-op when not configured
  _initialised = true;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

function _uuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return "e_" + Date.now() + "_" + Math.random().toString(36).slice(2);
}

// Track an event on both Pixel (browser) and CAPI (server), deduplicated by event_id.
export async function trackMetaEvent(eventName, params = {}, opts = {}) {
  if (!PIXEL_ID) return null;
  const eventId = opts.eventId || _uuid();

  try {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", eventName, params, { eventID: eventId });
    }
  } catch (_) { /* ignore */ }

  try {
    await axios.post(`${API}/analytics/meta`, {
      event_name: eventName,
      event_id: eventId,
      params,
      email: opts.email || undefined,
    }, { timeout: 5000 });
  } catch (_) { /* CAPI must never break the UX */ }

  return eventId;
}
